import { Injectable } from '@angular/core';

@Injectable()
export class AlertService {

    alerts: any[] = [];

    constructor() {
    }

    primary(content: string) {
        this.pushAlert('alert-primary', content);
    }

    secondary(content: string) {
        this.pushAlert('alert-secondary', content);
    }

    success(content: string) {
        this.pushAlert('alert-success', content);
    }

    danger(content: string) {
        this.pushAlert('alert-danger', content);
    }

    warning(content: string) {
        this.pushAlert('alert-warning', content);
    }

    info(content: string) {
        this.pushAlert('alert-info', content);
    }

    light(content: string) {
        this.pushAlert('alert-light', content);
    }

    dark(content: string) {
        this.pushAlert('alert-dark', content);
    }

    pushAlert(cssClass: string, content: string) {
        let alert = { class: cssClass, content: content };
        this.alerts.push(alert);
        setTimeout(() => this.dismissAlert(alert), 3500);
    }

    dismissAlert(alert: any) {
        this.alerts.splice(this.alerts.indexOf(alert), 1);
    }
}
